<template>
  <div>
    <el-dialog v-dialogDrag
               append-to-body
               destroy-on-close="true"
               title="发票拆分"
               :close-on-click-modal="false" :close-on-press-escape="false"
               :visible.sync="dialogInvoiceVisible"
               :width="invoiceSelect?'600px':'1000px'">
      <div v-loading="loading" :style="{ height: invoiceSelect?'292px':'487px' }">
        <invoiceType v-if="invoiceSelect" :invoiceActive="invoiceActive"
                     @changeInvoiceType="changeInvoiceType"></invoiceType>

        <div class="invoiceDetail">
          <invoiceTop v-if="!invoiceSelect"
                      :invoice-header.sync="invoiceHeader" :invoice-active="invoiceActive"
                      :invoice-split-name.sync="invoiceSplitName" :account-item-list="accountItemList"
                      :datas="invoiceDetailList"
                      @insertEvent="insertEvent" @backPrev="backPrev"></invoiceTop>

          <div v-show="!invoiceSelect" >
            <invoiceTable ref="invoiceTable"
                          v-if="(invoiceActive != 3 || invoiceActive == 3 && invoiceItemList.length > 0)&&isFirst"
                          :invoice-active="invoiceActive"
                          :names="tableColName"
                          :datas="invoiceDetailList"
                          :notice-id="noticeId"
                          :refname="invoiceRef"
                          :invoice-item-list.sync="invoiceItemList"
                          :invoice-title-list.sync="invoiceTitleList"
                          :sumItem="['totalAmount','amount','saleTax']"
                          :validRules.sync="validRules"
                          @backPrev="backPrev"
                          @closeDialog="closeDialog"
            ></invoiceTable>
          </div>
        </div>
      </div>
    </el-dialog>
    <div class="tanceng invoiceCeng" :class="{invoiceWidth:!invoiceSelect}" v-if="invoiceOpen"></div>
  </div>
</template>

<script>
  import { splitByDefault, splitByCostCenter, splitByHand ,getInvoiceTitleList,getInvoiceItemList,getOperateModeList} from "@/api/biz/bill/invoice";
  import { getNoticeInfo} from "@/api/biz/bill/pay-notice";
  import { mapGetters } from "vuex";

  import invoiceType from "./invoiceType";
  import invoiceTop from "./invoiceTop";
  import invoiceTable from "./invoiceTable";
  import {formatFloat} from "@/util/util"

  import {validatenumord } from '@/util/validate';

  export default {
    name: "invoiceSplit",
    components: { invoiceType, invoiceTop, invoiceTable },
    props: {
      noticeId: {
        type: String
      },
      cusId: {
        type: String
      },
      dialogInvoiceVisible: {
        type: Boolean,
        default: false
      },
    },
    create(){
    },
    watch: {
      dialogInvoiceVisible: {
        handler(newVal, oldVal) {
          // 在监听你使用update事件来更新listForm,而在父组件不需要调用该函数
          this.invoiceActive = 1;
          if(newVal){
            this.invoiceSelect = true;
            this.loading = false;
          }
          this.$emit("update:dialogInvoiceVisible", newVal);
        },
        immediate: true,
        deep: true
      }
    },
    data() {
      const notZero = ({ cellValue }) => {
        return new Promise((resolve, reject) => {
          if (cellValue == 0) {
            reject(new Error('金额不能为0'))
          } else {
            resolve()
          }
        })
      };
      return {
        isFirst:false,
        // cusId:null,
        loading: false,
        invoiceActive: 1,//选中的拆分类型，默认为默认
        invoiceSelect: true,//选择拆分类型页
        invoiceRef: "invoiceRef",
        invoiceHeader: {},
        invoiceSplitName: "默认发票抬头拆分",
        invoiceDetailList: {},
        invoiceDetailListLength: 0,
        invoiceItemList: {},
        invoiceTitleList: {},
        tableColName: [],
        defaultColName: [
          { type: "index", title: "序号", width: 50 },
          { field: "invoiceItemId", width: "100px", title: "票据项目", slots: { default: "invoiceItemId" } },
          // {
          //   field: "invoiceMonth",
          //   width: "150px",
          //   title: "开票月份",
          //   editRender: { name: "$input", props: { type: "month",valueFormat:'yyyy-MM' }}
          // },
          {
            field: "invoiceMonth",
            width: "150px",
            title: "开票月份",
            editRender: { name: "$input", props: { type: "String"},events: { blur: this.changeMonth },immediate: true}
          },
          { field: "invoiceType", width: "100px", title: "开票类型", slots: { default: "invoiceType" } },
          { field: "invoiceTitleName", width: "250px", title: "发票抬头" },
          { field: "totalAmount", width: "140px", title: "票据总金额",formatter: this.$options.filters['moneyFilter'] },
          { field: "rate", width: "50px", title: "税率",formatter:this.formatEmptyRate },
          { field: "saleTax", width: "130px", title: "销项税",formatter:this.formatEmpty },
          { field: "amount", width: "140px", title: "不含税金额",formatter: this.$options.filters['moneyFilter'] },
          { field: "operateMode", width: "100px", title: "操作模式", slots: { default: "operateMode" } },
          { field: "invoiceMedium", width: "100px", title: "发票介质", slots: { default: "invoiceMedium" } },
          { field: "remark", width: "100px", title: "备注", editRender: { name: "$input", props: { type: "String" } } }
        ],
        costCenterColName: [
          { type: "seq", title: "序号", width: 50 },
          { field: "costCenterName", width: "150px", title: "成本中心" },
          { field: "invoiceItemId", width: "100px", title: "票据项目", slots: { default: "invoiceItemId" } },
          {
            field: "invoiceMonth",
            width: "150px",
            title: "开票月份",
            editRender: { name: "$input", props: { type: "String"},events: { blur: this.changeMonth },immediate: true}
          },
          { field: "invoiceType", width: "100px", title: "开票类型", slots: { default: "invoiceType" } },
          { field: "invoiceTitleName", width: "250px", title: "发票抬头" },
          { field: "totalAmount", width: "140px", title: "票据总金额",formatter: this.$options.filters['moneyFilter'] },
          { field: "rate", width: "50px", title: "税率",formatter:this.formatEmptyRate },
          { field: "saleTax", width: "130px", title: "销项税",formatter:this.formatEmpty },
          { field: "amount", width: "140px", title: "不含税金额",formatter: this.$options.filters['moneyFilter'] },
          { field: "operateMode", width: "100px", title: "操作模式", slots: { default: "operateMode" } },
          { field: "invoiceMedium", width: "100px", title: "发票介质", slots: { default: "invoiceMedium" } },
          { field: "remark", width: "100px", title: "备注", editRender: { name: "$input", props: { type: "String" } } }
        ],
        handColName: [
          { type: "index", title: "序号", width: 50 },
          {
            field: "invoiceItemId",
            width: "150px",
            title: "票据项目",
            editRender: {
              name: "$select",
              options: [],
              optionProps: { value: 'invoiceItemId', label: 'invoiceItemName' },
              immediate: true,
              events: { change: this.changeEvent }
            },
            slots: { default: "invoiceItemId" }
          },
          {
            field: "invoiceMonth",
            width: "150px",
            title: "开票月份",
            editRender: { name: "$input", props: { type: "String"},events: { blur: this.changeMonth },immediate: true}
          },
          { field: "invoiceType", width: "100px", title: "开票类型", slots: { default: "invoiceType" } },
          { field: "invoiceTitleId",width: "250px",title: "发票抬头",
            editRender: {
              name: "$select",
              options: [],
              optionProps: {value: 'id', label: 'invoiceRise'},
              events:{change: this.changeTitle },
              immediate: true
            },
          },
          { field: "totalAmount", width: "140px", title: "票据总金额",
          formatter: this.$options.filters['moneyFilter'],
            editRender: { name: "$input", events: {change: this.computeTax},immediate: true  }
          },

          { field: "rate", width: "50px", title: "税率",formatter:this.formatEmptyRate },
          { field: "saleTax", width: "130px", title: "销项税",formatter:this.formatEmpty },
          { field: "amount", width: "140px", title: "不含税金额" ,formatter: this.$options.filters['moneyFilter']},
          { field: "operateMode", width: "100px", title: "操作模式", slots: { default: "operateMode" } },
          { field: "invoiceMedium", width: "100px", title: "发票介质", slots: { default: "invoiceMedium" } },
          { field: "remark", width: "100px", title: "备注", editRender: { name: "$input", props: { type: "String" } } },
          { title: "操作", width: "100px", showOverflow: true, fixed: "right", slots: { default: "operation" } }
        ],
        // 人工拆分校验
        validRules: {
          invoiceItemId:[
            { required: true, message: '票据项目必须填写' }
          ],
          invoiceMonth: [
            { required: true, message: '开票月份必须填写' }
          ],
          amount: [
            { required: true, message: '票据总金额必须填写' },
            { validator: notZero }
          ],
          invoiceTitleId: [
            { required: true, message: '发票抬头必须填写' }
          ],
        }
      };
    },
    computed: {
      ...mapGetters(["dicts"])

    },
    methods: {
      computeTax({row}){
        let init=row.totalAmount+"";
        row.totalAmount = formatFloat(init);

        if(row.invoiceItemId=="30410001") {//服务费需要算销项税
          row.saleTax = (Math.round(parseFloat(formatFloat(row.totalAmount))/1.06 * 0.06*100)/100);
          row.amount = Math.round(parseFloat(formatFloat(row.totalAmount)*100 - row.saleTax*100))/100;

          row.saleTax = parseFloat(row.saleTax.toFixed(2));
          row.amount = parseFloat(row.amount.toFixed(2));
        }else{
          row.amount = row.totalAmount;
        }
      },
      closeDialog() {
        this.$emit("closeDialog");
      },
      insertEvent() {
        this.$refs.invoiceTable.insertEvent();
      },
      //回到上一层
      backPrev() {
        this.invoiceSelect = true;
      },
      changeMonth({ row }) {
        if(row.invoiceMonth==null||row.invoiceMonth==""){
          row.invoiceMonth=row.initInvoiceMonth;
        }else if(row.invoiceMonth != row.initInvoiceMonth){
          // 判断年月类型
          var pattern = /^\d{4}\-((0[1-9])|(1[0-2]))$/;
          if(!pattern.test(row.invoiceMonth)){
            this.$message.error("请输入正确的年月（如2020-04）。");
          }
        }
      },
      changeTitle({ row }) {
        if(row.invoiceItemId==null||row.invoiceItemId==''){
          this.$message.error("请先选择开票项目");
          row.invoiceTitleId=null;
          return;
        }
        let invoiceInfo = this.invoiceTitleList.find(e=>e.id==row.invoiceTitleId);
        row.invoiceTitleName=invoiceInfo.invoiceRise;
        if(row.billType=='10420001'){
          console.log(row.invoiceItemId);
          console.log(invoiceInfo);
          console.log(invoiceInfo.isSpecialVatTicket);
          if(row.invoiceItemId =='30410001' && invoiceInfo.isSpecialVatTicket=='10020001') {
            row.invoiceType = '30300001';
            row.invoiceMedium = '30310001';
          }else {
            row.invoiceType = '30300002';
            row.invoiceMedium = invoiceInfo.invoiceMedium;
          }
        } else {
          row.invoiceType = '30300003';
          row.invoiceMedium = '30310001';
        }


        // for(let i=0;i<this.invoiceTitleList.length;i++){
        //   debugger
        //   let item=this.invoiceTitleList[i];
        //   if(item.id==row.invoiceTitleId){
        //     row.invoiceTitleName=item.invoiceRise;
        //     if(row.billType=='10420001'){
        //       item.invoiceType = item.isSpecialVatTicket='10020001'?'30300001':'30300002';
        //     } else {
        //       item.invoiceType = '30300003';
        //     }
        //     break;
        //   }
        // }
      },
      changeEvent({ row,rowIndex }) {
        for(let i=0;i<this.invoiceDetailList.length;i++){
          let item=this.invoiceDetailList[i];
          if(item.invoiceItemId==row.invoiceItemId){
            item.invoiceItemId=="30410001"?item.rate = "0.06":item.rate = "";
            row.rate=item.rate;
            row.invoiceType=item.invoiceType;
            row.invoiceMedium=item.invoiceMedium;
            row.operateMode=item.operateMode;
            row.initInvoiceMonth=item.invoiceMonth;
            row.invoiceMonth=item.invoiceMonth;
            row.totalAmount=item.totalAmount;
            console.log("row",row);
            if(item.invoiceItemId=="30410001" &&row.amount!=null){
              this.computeTax({row})
            }else if(item.invoiceItemId!="30410001"){
              row.saleTax = ""
            }

            console.log("item.invoiceType",item.invoiceType);
            if(item.invoiceType=='30300001'){//发票类型是增值税，不能选一般纳税人发票抬头
              for(var k=0;k<this.invoiceTitleList.length;k++){
                let title=this.invoiceTitleList[k];
                if(title.generalTaxpayer!="10020001"){
                  this.invoiceTitleList[k].disabled=true;
                  if(row.invoiceTitleId == this.invoiceTitleList[k].id){
                    row.invoiceTitleId = "";
                  }
                }else{
                  this.invoiceTitleList[k].disabled=false;
                }
              }
            }else{
              for(var k=0;k<this.invoiceTitleList.length;k++){
                let title=this.invoiceTitleList[k];
                this.invoiceTitleList[k].disabled=false;
              }
            }
            break;
          }
        }
      },
      getBillBaseInfo() {
        //获取客户配置的发票抬头
        getInvoiceTitleList(this.cusId).then(res => {
          this.invoiceTitleList = res.data.data;
        });
        //获取客户配置的开票项目
        getInvoiceItemList(this.cusId).then(res => {
          this.invoiceItemList = res.data.data;
          for (let i = 0; i < this.invoiceItemList.length; i++) {
            let item = this.invoiceItemList[i];
            let itemId = item.invoiceItemId;
            if (itemId == null) {
              itemId = item.receiptItemId;
              item.invoiceItemId = itemId;
            }
            let name = this.dicts.codeMap[itemId];
            item.invoiceItemName = name;
          }
        });
      },
      changeInvoiceType(n) {
        this.loading = true;
        this.invoiceActive = n;
        this.invoiceDetailList = [];
        this.tableColName = [];
        //按选择的拆分类型进行发票拆分
        if (n === 1) {//默认抬头拆分
          this.tableColName = this.defaultColName;
          splitByDefault(this.noticeId).then(res => {
            if (res.data.code == 0) {
              this.invoiceHeader = res.data.data.invoiceHeader;
              this.invoiceDetailList = res.data.data.invoiceDetail;
              for(let i=0;i<this.invoiceDetailList.length;i++){
                this.invoiceDetailList[i].initInvoiceMonth=this.invoiceDetailList[i].invoiceMonth;
              }
              this.invoiceSplitName = "默认发票抬头";
            } else {
              this.$message.error(res.data.msg);
            }
            this.isFirst = true;
            this.loading = false;
            this.invoiceSelect = false;
          });
        } else if (n === 2) {//成本中心拆分
          this.tableColName = this.costCenterColName;
          splitByCostCenter(this.noticeId).then(res => {
            if (res.data.code == 0) {
              this.invoiceHeader = res.data.data.invoiceHeader;
              this.invoiceDetailList = res.data.data.invoiceDetail;
              for(let i=0;i<this.invoiceDetailList.length;i++){
                this.invoiceDetailList[i].initInvoiceMonth=this.invoiceDetailList[i].invoiceMonth;
              }
              this.invoiceSplitName = "成本中心";
            } else {
              this.$message.error(res.data.msg);
            }
            this.isFirst = true;
            this.loading = false;
            this.invoiceSelect = false;
          });
        } else if (n === 3) {//人工拆分
          this.getBillBaseInfo();
          this.tableColName = this.handColName;
          this.invoiceSplitName = "人工拆分";
          //获取客户配置的开票项目
          splitByHand(this.noticeId).then(res => {
            if (res.data.code == 0) {
              this.invoiceHeader = res.data.data.invoiceHeader;
              this.invoiceDetailList = res.data.data.invoiceDetail;
              for(let i=0;i<this.invoiceDetailList.length;i++){
                this.invoiceDetailList[i].initInvoiceMonth=this.invoiceDetailList[i].invoiceMonth;
              }
              this.invoiceDetailListLength = this.invoiceDetailList.length;
            } else {
              this.$message.error(res.data.msg);
            }
            this.isFirst = true;
            this.loading = false;
            this.invoiceSelect = false;
          }).catch(err=> {
            this.loading = false;
          });
        }
        //记录开票项目的初始开票月份

      },
      // 格式化空值
      formatEmpty({cellValue}) {
        if (cellValue) {
          return this.$options.filters['moneyFilter'](cellValue);
        } else {
          return "--"
        }
      },
      formatEmptyRate({cellValue}) {
        if (cellValue) {
          return parseFloat(cellValue)*100+"%";
        } else {
          return "--"
        }
      },
    }
  };
</script>

<style scoped lang="scss">
  .dialogTitle {
    display: flex;
  }

  .tancengTitle {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .backBtn {
    margin-top: 3px;
  }
</style>
